import { populateDropdown, handleRegionSelect, populateCountryDropdown } from '../location_functions';
document.addEventListener("DOMContentLoaded", function () {
    
  // Get references to the dropdown elements
    const actionDropdown = document.getElementById("action-dropdown");
    const regionDropdown = document.getElementById("region-dropdown");
    const countryDropdown = document.getElementById("country-dropdown");
    const venueDropdown = document.getElementById("venue-dropdown");

    const selectedRegionValue = regionDropdown.value

    // Disable country and venue dropdowns initially
    countryDropdown.disabled = true;
    venueDropdown.disabled = true;

    if (selectedRegionValue) {
    // If a region is selected, populate the country dropdown
      populateCountryDropdown(selectedRegionValue);
      // const countryDropdown = document.getElementById("country-dropdown");
      // const selectedCountryValue = countryDropdown.value
      }



    // Function to populate a dropdown with options
    function populateDropdown(dropdown, data) {
      data.forEach((item) => {
        const option = document.createElement("option");
        option.value = item.id;
        option.text = item.name;
        dropdown.appendChild(option);
      });
    }


    function handleCountrySelect() {
      countryDropdown.addEventListener("change", function() {
        console.log("change event for countryDropdown detected");
        console.log("countryDropdown.value", countryDropdown.value);
        const selectedValue = countryDropdown.value;
        const url = `/locations/retrieve_children_of_location?id=${selectedValue}`;

        venueDropdown.innerHTML = `<option value="">Select Venue</option>`;
        venueDropdown.disabled = false;

        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            populateDropdown(venueDropdown, data);
            const selectedVenueId = venueDropdown.dataset.selectedVenueId;
            const options = venueDropdown.getElementsByTagName("option");
            for (let i = 0; i < options.length; i++) {
              if (options[i].value === selectedVenueId) {
              options[i].selected = true;
              break
          }
        }
          }

          )
          .catch((error) => {
            console.error("Error fetching data:", error);
          });

      });
    }
    // Function to handle submitting the form for different actions
    function handleFormSubmission() {

      const submitButton = document.getElementById("submit-button");
      const form = document.querySelector('.location-select-form');
    
      submitButton.addEventListener("click", function(e) {
        e.preventDefault();
        const selectedAction = getSelectedAction();
        const year = document.getElementById('year').value;
        const region = document.getElementById('region-dropdown').value;
        const country = document.getElementById('country-dropdown').value;

        if (selectedAction === '') {
          alert('Please choose an action');
          return false;
        }

        if (year === '') {
          alert('Please choose the year');
          return false;
        }

        if (selectedAction === 'input') {
           if (region === '')  {
            alert('Please select region');
            return false;
          }

          if (country === '')  {
            alert('Please select country');
            return false;
          }


        }



        submitButton.disabled = true;
        
    
        if (selectedAction === 'input') {
          form.action = "/statistics/new"; // Change to your actual endpoint for input statistics
        } else if (selectedAction === "report") {
          form.action = "/statistics/report"; // Change to your actual endpoint for generating a report
        }
    
        form.submit(); // Submit the form based on the updated action
      });
    }

    function submitForm() {
      const submitButton = document.getElementById("submit-button");
      const form = document.querySelector('.location-select-form');
      submitButton.disabled = true;
      e.preventDefault();
      
      const selectedAction = getSelectedAction()
  
      if (selectedAction === 'input') {
        form.action = "/statistics/new"; // Change to your actual endpoint for input statistics
      } else if (selectedAction === "report") {
        form.action = "/statistics/report"; // Change to your actual endpoint for generating a report
      }
  
      form.submit(); // Submit the form based on the updated action

    }

    function getSelectedAction() {
      const actionDropdown = document.getElementById('action-dropdown'); 
      const selectedAction = actionDropdown.value;

      return selectedAction
    }
  
  

      

  
  function updateLabelsBasedOnAction(selectedAction) {
    const regionLabel = document.querySelector('label[for="region-dropdown"]');
    const countryLabel = document.querySelector('label[for="country-dropdown"]');
    const venueLabel = document.querySelector('label[for="venue-dropdown"]');

    if (selectedAction === 'input'){
      regionLabel.textContent = 'Region (Required) :'
      countryLabel.textContent = 'Country (Required) :'
      venueLabel.textContent = 'Venue (Optional) :'

    } else if (selectedAction === "report") {
      regionLabel.textContent = 'Region (Optional) :'
      countryLabel.textContent = 'Country (Optional) :'
      venueLabel.textContent = 'Venue (Optional) :'
    }
  }


  function handleActionSelect () {
    
    actionDropdown.addEventListener("change", function() {
      const selectedAction = actionDropdown.value;

      updateLabelsBasedOnAction(selectedAction);
    });

  }

  
  const selectedAction = actionDropdown.value;
  updateLabelsBasedOnAction(selectedAction);

  handleRegionSelect();
  handleCountrySelect();
  handleFormSubmission();

  handleActionSelect();
  })